import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Modal, Icon } from 'antd'
import Login from '../login/Login'
import { Logo } from '../logo/Logo'
import { getWithDrawer } from '../../utils'
import { withRouter } from 'react-router'
import { setWidth } from '../../actions/AppAction'
import './public.css'

export class NavBar extends Component {

  constructor(props) {
    super(props)

    this.containerRef = React.createRef()

    this.state = {
      showNavBarItems: false,
      visibleDrawerLogin: false
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleSetCurrentWidht)
    setTimeout(() => {
      this.handleSetCurrentWidht()
    }, 1000)
  }

  showLogin = () => {
    this.setState({
      visibleDrawerLogin: true,
    })
  }

  onCloseLogin = () => {
    this.setState({
      visibleDrawerLogin: false,
    })
  }

  handleSetCurrentWidht = () => {
    if (this.containerRef && this.containerRef.current) {
      this.props.setWidth(this.containerRef.current.offsetWidth)
    }
  }


  render() {
    const { visibleDrawerLogin, showNavBarItems } = this.state
    const { intl } = this.props
    const classNavBar = classNames('pub-navbar-items', {
      'pub-navbar-toggle-show': showNavBarItems
    })

    const classNavBarRight = classNames('pub-navbar-items', 'pub-navbar-items-right', {
      'pub-navbar-toggle-show': showNavBarItems,
      'pub-navbar-holder': showNavBarItems
    })

    return (
      <React.Fragment>
        <div className="pub-navbar" ref={this.containerRef}>
          <div className="pub-navbar-link pub-navbar-link-brand">
            <Logo className="pub-site-logo" onClick={() => { this.props.history.push('/') }} />
          </div>
          <div className="pub-navbar-link pub-navbar-link-toggle pub-navbar-icon">
            <Icon type="profile" onClick={() => { this.setState({ showNavBarItems: !this.state.showNavBarItems }) }} />
          </div>
          <nav className={classNavBar}>
            <div className="pub-navbar-link" onClick={() => {
              this.props.history.push('/category/dam')
            }}>
              DAM´s
            </div>
            <div className="pub-navbar-link" onClick={() => {
              this.props.history.push('/category/marketing')
            }}>
              Marketing
            </div>
            <div className="pub-navbar-link" onClick={() => {
              this.props.history.push('/category/bunkey')
            }}>
              Bunkey
            </div>
          </nav>
          <nav className={classNavBarRight}>
            <div className="pub-navbar-link" style={{ marginRight: 0 }}>
              <span onClick={this.showLogin}><FormattedMessage id="login" /></span>
            </div>
          </nav>
        </div>
        <Modal
          title={intl.formatMessage({ id: "login_title" })}
          width={getWithDrawer()}
          onCancel={this.onCloseLogin}
          onClose={this.onCloseLogin}
          footer={null}
          visible={visibleDrawerLogin}>
          <Login />
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
  setWidth
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar)))